import FormControl from '@mui/material/FormControl'
import MenuItem from '@mui/material/MenuItem'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import { useContext, useEffect } from 'react'
import { inputContext } from '../../../../context/inputsContext'
import { useGetLocations } from '../../../../lib/hooks/api'

export const IntervalSelect = () => {
  const { values, setValues } = useContext(inputContext)
  const { data: positions } = useGetLocations()

  useEffect(
    () =>
      setValues((current) => {
        if (current.location === null && positions !== undefined)
          return { ...current, location: positions[0] }
        return current
      }),
    [positions, setValues],
  )

  return (
    <FormControl variant="standard" sx={{ m: 1, minWidth: 100 }}>
      <Select
        value={values.interval}
        id="simple-select"
        onChange={(event: SelectChangeEvent) =>
          setValues((c) => {
            return {
              ...c,
              interval: event.target.value as 'day' | 'hour',
            }
          })
        }
      >
        <MenuItem value="day">Day</MenuItem>
        <MenuItem value="hour">Hour</MenuItem>
      </Select>
    </FormControl>
  )
}

export default IntervalSelect
